import { redBtn, cancelBtn, labelStyle, inputStyle, modalOverlay, modalBox, modalHeader, closeBtn } from '../../styles/adminStyles';

function ProductCampaignModal({ productCampaignForm, setProductCampaignForm, products, onSave, onClose }) {
  const selectedProduct = products.find(p => p.id === productCampaignForm.productId);
  const discount = selectedProduct && productCampaignForm.campaignPrice
    ? (((selectedProduct.price - parseFloat(productCampaignForm.campaignPrice)) / selectedProduct.price) * 100).toFixed(0)
    : null;

  return (
    <div style={modalOverlay}>
      <div style={{ ...modalBox, width: '400px' }}>
        <div style={modalHeader}>
          <h2 style={{ margin: 0, fontSize: '18px' }}>Kampanya Ekle</h2>
          <button onClick={onClose} style={closeBtn}>×</button>
        </div>
        <div style={{ marginBottom: '14px' }}>
          <label style={labelStyle}>Ürün *</label>
          <select style={inputStyle} value={productCampaignForm.productId} onChange={e => setProductCampaignForm(p => ({ ...p, productId: e.target.value }))}>
            <option value="">Ürün Seçin</option>
            {products.filter(p => !p.isCampaign).map(p => <option key={p.id} value={p.id}>{p.name} ({p.price} TL)</option>)}
          </select>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Kampanya Fiyatı (TL) *</label>
          <input style={inputStyle} type="number" placeholder="İndirimli fiyat" value={productCampaignForm.campaignPrice} onChange={e => setProductCampaignForm(p => ({ ...p, campaignPrice: e.target.value }))} />
        </div>
        {discount !== null && (
          <div style={{ padding: '10px 14px', backgroundColor: '#F6EEDB', borderRadius: '6px', marginBottom: '16px', fontSize: '13px' }}>
            <strong style={{ color: '#111' }}>%{discount} indirim</strong> uygulanacak
          </div>
        )}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={onClose} style={cancelBtn}>İptal</button>
          <button onClick={onSave} style={redBtn}>Kaydet</button>
        </div>
      </div>
    </div>
  );
}

export default ProductCampaignModal;
